import config from 'src/constants';
import { authHeader } from '../_helpers';

import axios from '../axios-orders';
import axiosInstance from '../axios-orders';
import { Error, ErrorOutline } from '@material-ui/icons';
import {fetchWrapper} from '../_helpers/fetch-wrapper'
export const userService = {
    login,
    logout,
    register,
    //getAll,
    getById,
    getUserName,
    //update,
    //delete: _delete
    forgotPassword,
    changePassword
};

const LOGIN_URL = '/api/identity/oauth/token';
const AUTH_CREDENTIALS = `onemoreclientid:XY7kmzoNzl100`;
const AUTH_BASIC_HEADERS = {
    headers: {
      Authorization: `Basic ${btoa(AUTH_CREDENTIALS)}`,
      'Content-Type': 'application/x-www-form-urlencoded', 
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
      'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers'     
    },  
  };
  function Hearder() {
    const AUTH_CREDENTIALS = `onemoreclientid:XY7kmzoNzl100`;   
    let AUTH_BASIC_HEADERS = ""; 
      if(localStorage.getItem('user')===null){
        AUTH_BASIC_HEADERS = {
            headers: {
              Authorization: `Basic ${btoa(AUTH_CREDENTIALS)}`,
              'Content-Type': 'application/x-www-form-urlencoded', 
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
              'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers'     
            },          
          };
      }
      else{
        let user = JSON.parse(localStorage.getItem('user'));
         AUTH_BASIC_HEADERS = {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              'Content-Type': 'application/json', 
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
              'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers'     
            },          
          };
      }
      return AUTH_BASIC_HEADERS;
    }

function getUserName(){
   //console.log(localStorage.getItem('user'));
    if(localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).firstName && JSON.parse(localStorage.getItem('user')).lastName){
        return JSON.parse(localStorage.getItem('user')).firstName + " "+JSON.parse(localStorage.getItem('user')).lastName;
    }
    else{
        return "User";
    }    
}
function login(username, password) {    
    const header=Hearder();
    const passwordStr = `&password=${password}`;
    const params = `grant_type=password&username=${username}${passwordStr}`; 
    let response=false; 
    return axiosInstance()
    .post(LOGIN_URL,params,header)
    .then(handleResponse)
    .then(user => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user));    
        return user; 
         
 
    });    
}
function forgotPassword(email) {
  const param = {
    "email": email
  }
  return axiosInstance()
  .put('/api/identity/reset-password',param);
}
function changePassword(oldpassword,newpassword) {
  let user = JSON.parse(localStorage.getItem('user'));
  console.log(user.email,oldpassword,newpassword);
 const param = {
    "email": user.email,
     "newPassword": newpassword,
     "newPasswordConfirm": newpassword, 
     "oldPassword": oldpassword,     
  }
  return axiosInstance()
  .post('/api/identity/changePassword',param);
}
function logout() {    
    localStorage.removeItem('user');   
}
function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${config.apiUrl}/users/${id}`, requestOptions).then(handleResponse);
}
function register(user) { 
    const param = {
      "active": "true",
      "address": "",
      "blocked": "false",
      "email": user.email,
      "firstName": user.firstName,
      "gender": "",
       "id": 0,
      "lastName": user.lastName,
      "locale": "es",      
      "phone": "",
      "roleList": [
        1
      ],
      "timezone": "es",
      "username": user.email
      };    
      return fetchWrapper.post('/api/identity/signup',param).then(data => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes      
        return data;        
    });      
}
function handleResponse(response) {
    const data=response.data; 
    let error='';
    console.log(response);    
        if (!response.status===200) {
            if (response.status === 401) {                
                logout();
                window.location.reload(true);
            }           
         if (response.status === 400)
          { 
             error='Usuario o Contraseña incorrectas';
          }
        if ( response.status === 500) { 
           error='Hubo un error en la conexion del servidor'; 
          }
        if (!response.status) { 
          error='Hubo un error en la conexion del servidor'; 
        }                
            return Promise.reject(error);
        }
        return data;  
}